import clsx from 'clsx'
import Marquee from 'react-fast-marquee'
import { Link } from 'react-router-dom'

import Ellipse from 'assets/images/whySubhead/ellipse.svg'
import { Flex } from 'components/common/flex/Flex'
import { Typography } from 'components/common/typography/Typography'
import { ReactComponent as LinkArrowIcon } from 'components/whySubhead/assets/link-arrow.svg'
import { AnalyticsActionType } from 'types/analytics.type'

import styles from './WhySubhead.module.scss'
import { WhySubheadData } from './WhySubheadData'
import { trackAnalytics } from '../../utils/analytics'

const title = '•  Shaping Our Future  •  Shaping Our Future  •  Shaping Our Future '

export const WhySubhead = () => {
  const handleAnalytics = (event: string) => {
    trackAnalytics({
      type: AnalyticsActionType.action,
      payload: event,
    })
  }

  return (
    <div className={styles.container}>
      <Marquee className={styles.bottomContainer}>
        <Typography
          type="6xl-display"
          tag="p"
          className={`${styles.bottomText} font-normal uppercase italic`}
          color="#FE5645"
        >
          {title}
        </Typography>
      </Marquee>
      <div className={clsx([styles.flexRow, styles.contentContainer])}>
        <div className={styles.leftContainer}>
          <img src={Ellipse} alt="ellipse" className={styles.ellipse} />
          <div className={styles.contentWrapper}>
            <Typography className={`${styles.contentTitle} leading-[64px]`} type="5xl-display" color="#fff">
              The Future of Marketing:
            </Typography>
            <Typography
              className={clsx(styles.contentText, styles.contentTitle, 'inline-block leading-[64px]')}
              type="5xl-display"
              color="#fff"
            >
              Today
            </Typography>
          </div>
        </div>
        <div className={clsx(styles.rightContainer, styles.flexRow)}>
          {WhySubheadData.map(item => {
            return (
              <div className={styles.cardContainer} key={item.title}>
                <img src={item.img} alt="app" className={styles.imgContainer} />
                <Typography className={styles.cardTitle} type="l-strong" color="#40000f">
                  {item.title}
                </Typography>
                <Typography className={styles.cardText} type="m-body">
                  {item.description}
                </Typography>
                <Link
                  to={item.link}
                  target="_blank"
                  onClick={() => handleAnalytics(item.event_type)}
                  className={styles.cardLink}
                >
                  <Flex align="center" gap={4}>
                    <Typography className={styles.cardLinkText} type="m-strong">
                      Learn More
                    </Typography>
                    <LinkArrowIcon />
                  </Flex>
                </Link>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}
